module.exports = __webpack_public_path__ + "img/28a05b81538888fe8f24a913c0836b1d.svg";